import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import React from "react";

export default function Primaryqlinks() {
  return (
    <Card id="qlinksa" style={{padding:"15px"}}>
      <CardContent style={{fontFamily:"Karla,sans-serif"}}>
        <Typography variant="h4" style={{fontFamily:"Montserrat,sans-serif",fontWeight:"bolder",marginBottom:"15px"}}>QUICK LINKS</Typography>
          <ul>
            <li><a href="http://www.ldstsy.com/Ielts.aspx"><Typography variant="h6">Leadership development society (LDS)</Typography></a></li>
            <li><a href="http://ldstsy.com/mother/mother.html"><Typography variant="h6">Mother teresa IELTS & OET Training centre</Typography></a></li>
          </ul>
      </CardContent>
    </Card>
  );
}
